module.exports = __webpack_public_path__ + "static/media/webSite.787ecc2c.svg";